import { render } from "./i-plus.vue?vue&type=template&id=5c2e9a22"
import script from "./i-plus.vue?vue&type=script&lang=js"
export * from "./i-plus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__